<template>
<div class="chapter">
<div class="inner_page">
<p class="C96"><a id="page_xxi">TIMELINE OF RELEVANT EVENTS, ACCORDING TO RABBINIC TRADITION</a></p><a id="page_xxi">
<p class="C107"><img alt="" class="Image69" src="img/22_3.png" width="73%"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Timeline_of_Relevant_Events__Acc.vue?6b9465ba